/**
 * Agence'O - article-header
 * @author Guillaume Bouillon (Agence'O)
 * @created 02/09/2019
 */

(function ($) {

  if ($('.article-header__wrapper').length) {
    const wrapper = $('.article-header__wrapper');
    const clone = $('<div>').height(wrapper.height());
    let triggerPos = wrapper.position().top;

    $(window).on('scroll resize', (e) => {
      const scrollPos = window.scrollY;

      if (scrollPos >= triggerPos) {
        wrapper.addClass('is-sticky');
        wrapper.before(clone);
      } else {
        wrapper.removeClass('is-sticky');
        clone.remove();
      }

    }).resize();
  }

}(jQuery));
